class CustomAnalytics {
  constructor() {
    this.Shopify = Shopify;
    this.template = window.template;
    this.removeBtns = document.querySelectorAll('[data-cart-remove]');
    this.cart = document.querySelector('[data-cart]');
    this.accountForm = document.querySelector('form[action="/account"]');
    this.loginForm = document.querySelector('form[action="/account/login"]');

    this.collection = this.template.includes('collection');
    if (this.collection) {
      this.collectionContainer = document.querySelector('[data-collection]');
      this.collectionId = this.collectionContainer.dataset.collectionId;
      this.collectionTitle = this.collectionContainer.dataset.collectionTitle;
      this.impressions = [];
      this.maxImpressions = 0;
    }

    this.init();
  }

  /**
   * Publish a custom remove_from_cart GA4 event using Shopify Analytics
   */
  removeFromCart(btn) {
    const ecommProdId = `shopify_${this.Shopify.country}_${btn.dataset.productId}_${btn.dataset.variantId}`;
    const value = parseInt(btn.dataset.price) / 100;
    const totalValue = value * parseInt(btn.dataset.quantity);
    const data = {
      currency: this.Shopify.currency.active,
      ecommPageType: 'cart',
      ecommProdId: ecommProdId,
      ecommTotalValue: totalValue,
      items: [{
        id: ecommProdId,
        name: `${btn.dataset.productTitle} - ${btn.dataset.variantTitle}`,
        brand: btn.dataset.productVendor,
        category: btn.dataset.productType,
        price: value,
        quantity: btn.dataset.quantity,
        variant: btn.dataset.variantTitle
      }],
      value: totalValue
    }

    this.Shopify.analytics.publish('custom_remove_from_cart', data);
  }

  /**
   * Publish a custom view_cart GA4 event using Shopify Analytics
   */
  viewCart() {
    const items = document.querySelectorAll('[data-cart-line-item]');
    const value = parseInt(document.querySelector('[data-cart-subtotal]').dataset.cartSubtotal) / 100;
    const data = {
      currency: this.Shopify.currency.active,
      ecommPageType: 'cart',
      ecommTotalValue: value,
      items: [],
      value: value,
    }
    items.forEach((item) => {
      const ecommProdId = `shopify_${this.Shopify.country}_${item.dataset.productId}_${item.dataset.variantId}`;
      data.items.push({
        id: ecommProdId,
        name: `${item.dataset.productTitle} - ${item.dataset.variantTitle}`,
        brand: item.dataset.productVendor,
        category: item.dataset.productType,
        price: parseInt(item.dataset.price) / 100,
        quantity: item.dataset.quantity,
        variant: item.dataset.variantTitle
      });
    });

    this.Shopify.analytics.publish('custom_view_cart', data);
  }

  /**
   * Publish a custom view_item_list GA4 event using Shopify Analytics
   */
  viewItemList() {
    const data = {
      item_list_id: this.collectionId,
      item_list_name: this.collectionTitle,
      items: this.impressions
    };

    this.Shopify.analytics.publish('custom_view_item_list', data);
  }

  /**
   * Publish a custom login GA4 event using Shopify Analytics
   */
  login() {
    const data = {
      method: 'Online Store'
    }

    this.Shopify.analytics.publish('custom_login', data);
  }

  /**
   * Publish a custom sign_up GA4 event using Shopify Analytics
   */
  signUp() {
    const data = {
      method: 'Online Store'
    }

    this.Shopify.analytics.publish('custom_sign_up', data);
  }

  /**
   * Set maxImpressions with value
   */
  setMaxImpressions(value) {
    this.maxImpressions = value;
  }

  /**
   * Append impression to list
   */
  addImpression(element, position) {
    const data = {
      id: `shopify_${this.Shopify.country}_${element.dataset.productId}`,
      name: element.dataset.productTitle,
      brand: element.dataset.productVendor,
      category: element.dataset.productType,
      price: element.dataset.productPrice,
      index: position
    };
    this.impressions.push(data);
  }

  /**
   * Detect collection page scroll events, add unique impressions
   */
  detectImpressions() {
    if (this.maxImpressions == 0) {
      this.setMaxImpressions(document.querySelectorAll('[data-product-tile]').length);
    }
    if (this.impressions.length < this.maxImpressions) {
      const currSet = document.querySelectorAll('[data-product-tile]');
      Array.from(currSet).forEach((element, index) => {
        if (element.dataset.viewed === undefined && element.getBoundingClientRect().top < window.innerHeight) {
          const position = index + 1;
          this.addImpression(element, position);
          element.dataset.viewed = true;
        }
      });
    }
  }

  /**
   * Bind cart remove line item buttons
   */
  bindRemoveBtns() {
    this.removeBtns.forEach((btn) => {
      btn.addEventListener('click', () => this.removeFromCart(btn));
    });
  }

  events() {
    if (this.removeBtns) {
      this.bindRemoveBtns();
    }

    document.addEventListener('cart:updated', () => {
      this.removeBtns = document.querySelectorAll('[data-cart-remove]');
      this.bindRemoveBtns();
    });

    document.addEventListener('cart:opened', () => {
      this.viewCart();
    });

    if (this.accountForm) {
      this.accountForm.addEventListener('submit', () => {
        this.signUp();
      });
    }

    if (this.loginForm) {
      this.loginForm.addEventListener('submit', () => {
        this.login();
      });
    }

    if (this.collection) {
      document.addEventListener('scroll', debounce(() => {
        this.detectImpressions();
      }, 100));

      window.addEventListener('beforeunload', () => {
        this.viewItemList();
      });
    }
  }

  init() {
    this.events();
  }
}

new CustomAnalytics();